import React from "react";
import moment from "moment";
import { EMPTY } from "constants/common";
import { ColumnType } from "antd/lib/table";
import { LearningProgressModel } from "types/model/customer";
import CourseCompleted from "components/CourseCompleted";

const columnConfig: ColumnType<LearningProgressModel>[] = [
  {
    title: "Subuser",
    dataIndex: "subUserName",
    width: 114,
    ellipsis: true,
    render: (value) => value || EMPTY,
  },
  {
    title: "Course",
    dataIndex: "courseName",
    width: 114,
    ellipsis: true,
    defaultSortOrder: "ascend",
    sortDirections: ["descend", "ascend", "descend"],
    sorter: true,
    render: (value) => value || EMPTY,
  },
  {
    title: "Lesson No.",
    dataIndex: "lessonNumber",
    width: 147,
    ellipsis: true,
    defaultSortOrder: "ascend",
    sortDirections: ["descend", "ascend", "descend"],
    sorter: true,
    render: (value) => value ?? EMPTY,
  },
  {
    title: "First activity date",
    dataIndex: "firstActivityDate",
    width: 196,
    ellipsis: true,
    sortDirections: ["descend", "ascend", "descend"],
    sorter: true,
    render: (value) => (value ? moment(value).format("YYYY-MM-DD") : EMPTY),
  },
  {
    title: "Last activity date",
    dataIndex: "lastActivityDate",
    width: 196,
    ellipsis: true,
    sortDirections: ["descend", "ascend", "descend"],
    sorter: true,
    render: (value) => (value ? moment(value).format("YYYY-MM-DD") : EMPTY),
  },
  {
    title: "Completed",
    dataIndex: "isCompleted",
    width: 147,
    ellipsis: true,
    sortDirections: ["descend", "ascend", "descend"],
    sorter: true,
    render: (value) => <CourseCompleted completed={value} />,
  },
  {
    title: "Listen time(Mins)",
    dataIndex: "listenTimeMinutes",
    width: 196,
    ellipsis: true,
    sortDirections: ["descend", "ascend", "descend"],
    sorter: true,
    render: (value) => value ?? EMPTY,
  },
  {
    title: "Platform",
    dataIndex: "sourcePlatform",
    width: 114,
    ellipsis: true,
    render: (value) => value ?? EMPTY,
  },
];

export default columnConfig;
